<div class="port-agent-form-container">
    <div class="top-section">
        <span class="dis_id">{{fdaEditData?.disbursement_id}} - {{fdaEditData?.fda?.status_name}}</span>
        <div class="service-button-section">
            <div class="currency-marquee"
                *ngIf="portAgentForm.get('fda_currency_from')?.value && portAgentForm.get('fda_currency_to')?.value && portAgentForm.get('fda_roe')?.value">
                <span class="marquee-text">
                    Note: 1 {{ portAgentForm.get('fda_currency_from')?.value }} ~=
                    {{ portAgentForm.get('fda_roe')?.value }}
                    {{ portAgentForm.get('fda_currency_to')?.value }}
                    <ng-container *ngIf="shouldShowConvertedCurrencyMarquee()">
                        , 1 {{ portAgentForm.get('converted_curr_from')?.value }} ~=
                        {{ portAgentForm.get('conversion_fda_rate')?.value }}
                        {{ portAgentForm.get('converted_curr_to')?.value }}
                    </ng-container>
                </span>
            </div>
            <button type="button" (click)="refreshTariffRules()" class="text-icon" style="height: 30px"
                [disabled]="disableTableInputFields" [ngClass]="{'disabled-input': disableTableInputFields}"
                matTooltip="Refresh tariff rules with master data">Reload Tariff
                <mat-icon>refresh</mat-icon></button>

            <div style="display: flex; align-items: center; margin-top: -8px;">
                <mat-slide-toggle class="small-toggle" [formControl]="fda_custom_calculation"></mat-slide-toggle>
                <span style="font-size: 15px; font-weight: 500; width: 120px; color: var(--color-white);">
                    {{ fda_custom_calculation.value ? "User Defined" : "System Defined" }}
                </span>
            </div>
            <button type="button" (click)="recalculateData()" class="text-icon" style="height: 30px"
                [disabled]="disableTableInputFields" [ngClass]="{'disabled-input': disableTableInputFields}">Calculate
                <mat-icon>calculate</mat-icon></button>
            <button type="button" class="text-icon" style="height: 30px" (click)="downloadReport()"
                [disabled]="fdaEditData?.pda?.status === 5"
                [ngClass]="{'disabled-input': fdaEditData?.pda?.status === 5}">
                FDA Report <mat-icon>download</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="scrollable-section" [ngClass]="{ 'theme-dark': isDarkMode() }">
    <form [formGroup]="portAgentForm" (ngSubmit)="onSubmit('')">
        <div class="field-section">
            <div class="field-grid">
                <div *ngFor="let field of fields; let i = index">
                    <mat-form-field *ngIf="field.type === 'select' && field.value && portAgentForm.get(field.value)"
                        appearance="outline">
                        <mat-label>{{ field.name }}</mat-label>
                        <input type="text" matInput [formControlName]="field?.value" [matAutocomplete]="auto"
                            (click)="trigger.openPanel()" #trigger="matAutocompleteTrigger" />

                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect(field.name, $event.option)"
                            [displayWith]="displayFn.bind(this, field)">
                            <mat-option *ngFor="let opt of getFilteredOptions(field)"
                                [value]="getOptionValue(field, opt, addedFields)">
                                {{ field.name === 'Cargo' ? opt?.type : (field.name === 'ToCurrency' || field.name ===
                                'FromCurrency') ? opt : opt?.name }}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            Please select the {{ field.name }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                        *ngIf="field.type === 'date' && field.value && portAgentForm.get(field.value)">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="field.value"
                            (dateChange)="onDateChange()" />
                        <!-- Datepicker -->
                        <mat-datepicker-toggle matIconSuffix [for]="picker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            please select the {{ field.name }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field
                        [ngClass]="{ 'changed-field': modifiedFields[field.value] && !isExcludedFlag(field.value) }"
                        *ngIf="field.type !== 'date' && field.type !== 'select' && !isExcludedField(field.value) && field.value && portAgentForm.get(field.value)"
                        appearance="outline">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [type]="field.data_type || 'text'" [formControlName]="field.value"
                            [readonly]="isFieldReadonly(field)" />

                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            {{ field.name }} is required
                        </mat-error>

                        <span mat-icon-button *ngIf="modifiedFields[field.value] && !isExcludedFlag(field.value)"
                            matSuffix disabled class="flag-indicator">
                            🚩
                        </span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="converted-currency-section">
            <mat-form-field appearance="outline">
                <mat-label>Converted Currency From</mat-label>
                <input matInput [matAutocomplete]="convertedCurrencyAutocomplete" formControlName="converted_curr_from">
                <mat-autocomplete #convertedCurrencyAutocomplete="matAutocomplete">
                    <mat-option *ngFor="let currency of ConvertedFromCurrencyList" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>


            <mat-form-field appearance="outline">
                <mat-label>Converted Currency To</mat-label>
                <input matInput [matAutocomplete]="portAgentAutocomplete" formControlName="converted_curr_to">
                <mat-autocomplete #portAgentAutocomplete="matAutocomplete"
                    (optionSelected)="onSelect('Converted Currency To', $event.option)">
                    <mat-option *ngFor="let currency of filteredConvertedToCurrency | async" [value]="currency"> {{
                        currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Conversion FDA Rate</mat-label>
                <input matInput formControlName="conversion_fda_rate" type="number" />
            </mat-form-field>
        </div>

        <div class="common-table-header" *ngIf="datasource.data && datasource.data.length > 0">
            <div class="table-header">
                <div *ngFor="let column of displayedColumns">
                    <h6>{{ column }}</h6>
                </div>
            </div>
        </div>

        <ng-container *ngFor="let service of datasource.data; let i = index">
            <div class="table-outer" *ngIf="!service.get('isSubService')?.value">
                <div class="table-section">
                    <div class="table-inner">
                        <div class="table-content" [formGroup]="service">
                            <div style="display: flex; gap: 0;">
                                <div>
                                    <h6>{{ getMainServiceIndex(i, datasource.data) }}</h6>
                                </div>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <input *ngIf="service.get('isNew')?.value" matInput type="text" class="service-name"
                                        [formControl]="service.get('service')" placeholder="Enter service name"
                                        style="width: 100%; padding: 5px; border: 1px solid var(--app-border); border-radius: 4px; font-size: 13px;::placeholder{font-size:12px;}" />
                                    <h6 *ngIf="!service.get('isNew')?.value">{{ service.get('service')?.value }}</h6>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 15px;">
                                    <div style="display: flex; flex-direction: column; gap: 5px;">
                                        <div style="display: flex; flex-direction: row; gap: 5px;">
                                            <span style="font-size: 10px; font-weight: 500; color: var(--app-text-primary);">
                                                IN({{fromCurrency}})</span>
                                            <input matInput type="number"
                                                [formControl]="service.get(service.get('isSubService')?.value ? 'systemSubTotal' : 'systemTotal')"
                                                (input)="calculateMerakiServicegrandTotal()" readonly />
                                        </div>
                                    </div>
                                    <div style="display: flex; flex-direction: column; gap: 5px;">
                                        <div style="display: flex; flex-direction: row; gap: 5px;">
                                            <span style="font-size: 10px; font-weight: 500; color: var(--app-text-primary);">
                                                IN({{toCurrency}})</span>
                                            <input matInput type="number"
                                                [value]="calculateSystemAndAgentValueWithRoe(service, 'system', 'ToCurrency')"
                                                readonly />
                                        </div>
                                    </div>
                                    <div style="display: flex; flex-direction: column; gap: 5px;"
                                        *ngIf="displayConvertedToCurrency">
                                        <div style="display: flex; flex-direction: row; gap: 5px;">
                                            <span style="font-size: 10px; font-weight: 500; color: var(--app-text-primary);">
                                                IN({{convertedToCurrencyValue}})</span>
                                            <input matInput type="number"
                                                [value]="calculateSystemAndAgentValueWithRoe(service, 'system', 'convertedToCurrency')"
                                                readonly />
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="withPda" style=" display: flex; flex-direction: column; gap: 15px;">
                                    <input type="number" [value]="service.get('pdaApprovedTotalValue')?.value" readonly
                                       >
                                    <input type="number"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'pda-approved', 'ToCurrency')"
                                        readonly>
                                    <input type="number"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'pda-approved', 'convertedToCurrency')"
                                        readonly *ngIf="displayConvertedToCurrency">

                                </div>
                                <div style=" display: flex; flex-direction: column; gap: 15px;">
                                    <input matInput type="number"
                                        [formControl]="service.get(service.get('isSubService')?.value ? 'sub_total' : 'total')"
                                        (input)="onAgentValueChange(service)" (keydown)="restrictDecimal($event, 2)"
                                        (focus)="onTotalFocus(service, null)" (blur)="onTotalBlur(service, null)">

                                    <input matInput type="number"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'agent', 'ToCurrency')"
                                        readonly />
                                    <input matInput type="number"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'agent', 'convertedToCurrency')"
                                        readonly *ngIf="displayConvertedToCurrency" />
                                </div>
                                <span *ngIf="shouldShowFlag(service)" style="text-align: center;">🚩</span>

                                <div
                                    style="display: flex; align-items: center; justify-content: left; margin-left: -10px;">
                                    <mat-slide-toggle [checked]="service.get('negotiate')?.value === 'Y'"
                                        (change)="onAgreedNegotiateToggle(service, $event.checked)" color="primary"
                                        style="transform: scale(0.5);"
                                        [ngClass]="service.get('negotiate')?.value === 'Y' ? 'toggle-negotiate' : 'toggle-agreed'">
                                    </mat-slide-toggle>
                                    <span style="font-size: 14px; font-weight: 500; color: var(--color-white);">
                                        {{ service.get('negotiate')?.value === 'Y' ? 'Negotiate' : 'Agreed' }}
                                    </span>
                                </div>
                                <mat-icon *ngIf="service.get('isNew')?.value" (click)="submitServiceName(service)"
                                    style="margin-left: 20px; cursor: pointer; color: var(--color-success); font-size: 24px;"
                                    matTooltip="Submit service name">
                                    check
                                </mat-icon>
                                <mat-icon *ngIf="canDeleteSpecificService(service)" (click)="deleteService(service)"
                                    style="margin-left: 10px; color: var(--app-status-error); cursor: pointer;" matTooltip="Delete service">
                                    delete
                                </mat-icon>
                            </div>
                            <div>
                                <h6>{{ service.get("info_msg")?.value }}</h6>
                            </div>
                        </div>
                        <div class="service-note-2" [ngClass]="getServiceNoteClass(service)"
                            *ngIf="shouldShowServiceNote(service) && service.get('subService')?.value?.length === 0">
                            <h6>Note:</h6>
                            <p>{{ getServiceNoteMessage(service) }}</p>
                        </div>
                        <div class="table-service" *ngIf="service.get('subService')?.value?.length > 0">
                            <div class="empty-space">
                            </div>
                            <div class="warning-section">
                                <div class="table-checkbox" *ngIf="service.get('subService')?.value.length > 0">
                                    <mat-checkbox
                                        *ngFor="let subService of service.get('subService')?.value; let i = index"
                                        [checked]="!subService.optional"
                                        (click)="onCheckboxClick(service, subService, i)"
                                        [style.display]="subService.hide === 'Y' ? 'none' : 'flex'">
                                        {{ subService.name || service.get('service')?.value }}
                                    </mat-checkbox>
                                </div>
                                <div class="movement-section">
                                    <div class="movement-inputs" *ngIf="service.get('subService')?.value.length > 0">
                                        <div class="movement-item"
                                            *ngFor="let subServiceControl of service.get('subService')?.controls; let j = index"
                                            [formGroup]="subServiceControl"
                                            [style.display]="service.get('subService')?.value[j]?.hide === 'Y' ? 'none' : 'block'">

                                            <textarea rows="2"
                                                [formControl]="subServiceControl.get('formattedSystemMovement')"
                                                class="movement-textarea" appAutoResizeInput [minWidth]="150"
                                                [maxWidth]="280" [bufferSpace]="30">
                                                  </textarea>
                                        </div>

                                    </div>
                                </div>
                                <div class="service-note" [ngClass]="getServiceNoteClass(service)"
                                    *ngIf="shouldShowServiceNote(service)">
                                    <h6>Note:</h6>
                                    <p>{{ getServiceNoteMessage(service) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-textarea" [formGroup]="service">
                        <div>
                            <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" readonly class="textarea-1"
                                placeholder="Port Agent Remark" rows="2" formControlName="pa_remark"></textarea>
                        </div>
                        <div>
                            <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" class="textarea-2"
                                placeholder="Meraki Feedback" rows="2" formControlName="meraki_feedback"></textarea>
                        </div>
                        <div>
                            <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" readonly class="textarea-3"
                                placeholder="Client Comment" rows="2"
                                formControlName="formated_client_comment"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>


        <div class="total-section" *ngIf="datasource.data && datasource.data.length > 0">
            <div class="total-item">
                <label style="color: var(--app-text-primary);">System Total :</label>
                <div style="display: flex; flex-direction: column; row-gap: 10px;">

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ fromCurrency }})</span>
                        <input type="number" [value]="getSystemGrandTotal()" readonly />
                    </div>

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ toCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('system', 'ToCurrency')" readonly />
                    </div>
                    <div style="display: flex; align-items: center; column-gap: 12px;"
                        *ngIf="displayConvertedToCurrency">
                        <span class="currency-text">IN({{ convertedToCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('system', 'convertedToCurrency')"
                            readonly />
                    </div>

                </div>


            </div>

            <div class="total-item" *ngIf="withPda">
                <label style="color: var(--app-text-primary);">PDA Approved Total:</label>
                <div style="display: flex; flex-direction: column; row-gap: 10px;">

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ fromCurrency }})</span>
                        <input type="number" [value]="getPdaGrandTotal()" readonly />
                    </div>

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ toCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('pda-approved', 'ToCurrency')" readonly />
                    </div>
                    <div style="display: flex; align-items: center; column-gap: 12px;"
                        *ngIf="displayConvertedToCurrency">
                        <span class="currency-text">IN({{ convertedToCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('pda-approved', 'convertedToCurrency')"
                            readonly />
                    </div>

                </div>


            </div>
            <div class="total-item">
                <label style="color: var(--app-text-primary);">Agent Value Total:</label>
                <div style="display: flex; flex-direction: column; row-gap: 10px;">

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ fromCurrency }})</span>
                        <input type="number" [value]="agentServiceGrandTotal" readonly />
                    </div>

                    <div style="display: flex; align-items: center; column-gap: 12px;">
                        <span class="currency-text">IN({{ toCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('agent', 'ToCurrency')" readonly />
                    </div>
                    <div style="display: flex; align-items: center; column-gap: 12px;"
                        *ngIf="displayConvertedToCurrency">
                        <span class="currency-text">IN({{ convertedToCurrency }})</span>
                        <input type="number" [value]="getSystemAndAgentTotal('agent', 'convertedToCurrency')"
                            readonly />
                    </div>

                </div>

            </div>

        </div>

        <div class="footer-section">
            <mat-form-field appearance="outline">
                <mat-label>Credit Notes</mat-label>
                <input matInput formControlName="credit_note" (input)="recalculateTotals()" type="number" />
                <mat-error *ngIf="portAgentForm.get('credit_note')?.hasError('required')">
                    Credit note is required
                </mat-error>
                <mat-error *ngIf="portAgentForm.get('credit_note')?.hasError('maxCreditExceeded')">
                    Credit note cannot exceed Grand Total
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Grand Total</mat-label>
                <input readonly matInput formControlName="fda_amount" (input)="recalculateTotals()" />
                <mat-error *ngIf="portAgentForm.get('fda_amount')?.hasError('required')">
                    Grand total is required
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Payment Currency From</mat-label>
                <input matInput [matAutocomplete]="PaymentAutocomplete" formControlName="pmt_curr_from">
                <mat-autocomplete #PaymentAutocomplete="matAutocomplete"
                    (optionSelected)="onSelect('Payment Currency From', $event.option)">
                    <mat-option *ngFor="let currency of PaymentFromCurrencyList" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Payment Currency To</mat-label>
                <input matInput [matAutocomplete]="portAgentAutocompletebelowSection" formControlName="pmt_curr_to">
                <mat-autocomplete #portAgentAutocompletebelowSection="matAutocomplete">
                    <mat-option *ngFor="let currency of filteredPaymentToCurrency | async" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Payment Currency Rate</mat-label>
                <input matInput formControlName="conversion_rate" (input)="recalculateTotals()" type="number" />
                <mat-error *ngIf="portAgentForm.get('conversion_rate')?.hasError('required')">
                    Conversion Rate is required
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label> Currency Conversion</mat-label>
                <input readonly matInput formControlName="currency_conversion" />
            </mat-form-field>
            <mat-form-field *ngIf="withPda" appearance="outline">
                <mat-label>PDA Remittance</mat-label>
                <input readonly matInput formControlName="pda_remittance" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Balance Due</mat-label>
                <input readonly matInput formControlName="balance_due" />
            </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 10px; margin: 10px 20px;">
            <div class="currency-conversion-mismatch-banner" *ngIf="showCurrencyConversionMismatchBanner">
                <span class="banner-text"> Currency Conversion Mismatch: Calculated value
                    ({{calculatedCurrencyConversion | number:'1.2-2'}}) Entered ({{responseCurrencyConversion |
                    number:'1.2-2'}})</span>
            </div>
        </div>
    </form>

    <app-comm-history [data]="communicationHistory"></app-comm-history>

    <div class="top-section">
        <span></span>
        <div class="button-section">
            <button class="text-icon" [disabled]="disableTableInputFields"
                [ngClass]="{'disabled-input': disableTableInputFields}" style="height: 30px" (click)="upload()">Upload
                File <mat-icon>cloud_upload</mat-icon>
            </button>
            <button class="warning-action-btn" [disabled]="disableTableInputFields"
                *ngIf="isNegotiateSelected && (fdaStatus === 1 || fdaStatus === 9)"
                (click)="fdaEditSubmitAndSave('Request Approval')">
                Request Approval</button>
            <button (click)="openCreateServiceDialog()" [disabled]="disableTableInputFields"
                [ngClass]="{'disabled-input': disableTableInputFields}" type="button">Add Service</button>
            <button (click)="onSave('save')" [disabled]="disableTableInputFields"
                [ngClass]="{'disabled-input': disableTableInputFields}" type="button">Save</button>
            <button (click)="onSubmit('Submit')" [disabled]="disableTableInputFields" *ngIf="!isNegotiateSelected"
                [ngClass]="{'disabled-input': disableTableInputFields}" type="button">Submit</button>
        </div>
    </div>
</div>
